import notify from "devextreme/ui/notify";
import { confirm, alert } from "devextreme/ui/dialog";
import DataSource from "devextreme/data/data_source";
import ApiHelper from "./api-helper";
import CustomStore from "devextreme/data/custom_store";
import { formatNumber as dxFormatNumber } from "devextreme/localization";
import { DateTime } from "luxon";
import Guid from "devextreme/core/guid"

class Helper {
  static toast(msg = '<i>Apakah Anda yakin?</i>', type = "info") {
    notify(msg, type);
  }

  static info(msgHtml, title = "Informasi") {
    alert(msgHtml, title);
  }

  static konfir(msgHtml = "<i>Apakah Anda yakin?</i>", title = "Konfirmasi") {
    return confirm(msgHtml, title);
  }

  static createGridDataSource(path) {
    return new DataSource(this.createCustomStoreConfig(path));
  }

  static createCustomStoreConfig(path) {
    return {
      key: "id",
      load(loadOptions) {
        return new Promise((resolve, reject) => {
          ApiHelper.post(path, loadOptions)
            .then((data) => {
              resolve(data);
            })
            .catch((e) => reject(e));
        });
      },
      byKey(key) {
        return new Promise((resolve, reject) => {
          ApiHelper.post(path, { id: key })
            .then((data) => {
              resolve(data);
            })
            .catch((e) => reject(e));
        });
      },
    };
  }

  static createLookupDataSource(path) {
    let store = new CustomStore(this.createCustomStoreConfig(path));
    return new DataSource({
      store,
      paginate: true,
      pageSize: 20,
    });
  }

  static readFileAsBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        resolve(reader.result);
      };
      reader.onerror = (error) => {
        reject(error);
      };
      reader.readAsDataURL(file);
    });
  }

  static setDaftarAkses(daftar_akses, konfigurasi) {
    if(!konfigurasi) {
      return
    }
    for (var k of konfigurasi) {
      let temp = k.split(":");
      let key = temp[0];
      let akses = temp[1];
      let itm = daftar_akses.find((x) => x.key === key);
      if (itm) {
        itm[akses] = true;
      }
    }
  }

  static formatNumber(n) {
    return dxFormatNumber(n, '#,##0.##')
  }

  static formatDate(d, format = 'yyyy-MM-dd HH:mm:ss') {
    if (!d) {
      return ''
    }
    let t = null
    if (d instanceof Date) {
      t = DateTime.fromJSDate(d)
    } else {
      d = d.replace(/\//g, '-')
      t = DateTime.fromFormat(d, format)
    }
    return t.toISODate()
  }

  static uuid(length = 8) {
    // Generate a new UUID
    var newUUID = new Guid().toString();

    // Use the new UUID as a string
    return newUUID.replace(/-/g, '').substring(0, length)
  }

  static parseFloat(n) {
    let s = parseFloat(n)
    if(isNaN(n)) {
      return null
    }
    return s
  }

}

export default Helper;
